import { IonButton } from "@ionic/react";

interface Props {
  setWalkBack: Function;
}
const WalkBackModal: React.FC<Props> = ({ setWalkBack }) => {
    return (
        <>

            <div className="generic-assesment-text-modal">
                    <h1 className="fz-30 fw-700 align-center lh-normal mb-0">Walk back to the </h1>
                    <h1 className="fz-30 fw-700 align-center lh-normal mt-0 mb-0">start line.</h1>
                    <h1 className="fz-30 fw-700 align-center lh-normal mb-0 text-top"> Screen will flash </h1>
                    <h1 className="fz-30 fw-700 align-center lh-normal mb-0">green when ready. </h1>
            </div>
        </>
    );
};
export default WalkBackModal;

